import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import React from 'react';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import {
  SignedInNavigationScreenNavigationProp,
  SignedInRootStackParamList,
} from '../../../../../routes/types';
import {
  fixedIncomeFiltersQuery,
  fixedIncomeAssetsQuery,
} from '../../../../../store/customerAssetDetail/selector';
import { FixedIncomeAssetsQueryItem } from '../../../../../store/customerAssetDetail/types';
import { productMarketStatusSelector } from '../../../../../store/product/selector';
import { ProductWithMarketStatus } from '../../../../../store/product/types';
import { FeatureToggle, useUnleashFlags } from '../../../../../utils/useUnleashFlags';
import { DynamicAssetTableProps } from '../../DynamicAsset';
import { DynamicProductTable } from '../_dynamic';

import { FixedIncomeDetails } from './components/FixedIncomeDetails';
import { tableHead } from './constants';
import ProductItem from './item';

export const FixedIncomeTable: React.FC<DynamicAssetTableProps> = (props) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { params } = useRoute<RouteProp<SignedInRootStackParamList, 'CustomersAssetsDetails'>>();
  const { data: marketStatusData } = useRecoilQuery(
    productMarketStatusSelector({ product: ProductWithMarketStatus.FixedIncome })
  );

  const { b2bRedemptionSolicitationEnabled } = useUnleashFlags(
    FeatureToggle.RedemptionSolicitationIsEnabled
  );
  const handlePressQuoteButton = (product: FixedIncomeAssetsQueryItem) => {
    navigate('RedemptionSolicitation', {
      ...params,
      productId: product.uniqueCodeNormalized,
      productName: product.productNameNormalized,
      productType: 'FixedIncome',
      quote: product.quoteNormalized,
    });
  };

  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={fixedIncomeAssetsQuery}
      filtersQuery={fixedIncomeFiltersQuery}
      tableHeadItems={tableHead}
      tabletColumns={5}
      tabletRows={2}
      tabletSecondaryInfo={FixedIncomeDetails}
      mobileSecondaryInfo={FixedIncomeDetails}
      mobileColumns={3}
      mobileRows={2}
      quoteButtonInfoGetter={(item) => ({
        hasQuote: !!item.quoteNormalized,
        isDisabled:
          (!item.isPermittedToRedeem && !item.isPermittedToApprove) || !marketStatusData?.isOpen,
        customProps: !b2bRedemptionSolicitationEnabled ? { display: 'none' } : {},
        onPress: () => handlePressQuoteButton(item),
      })}
      tabletFields={[
        { key: 'productNameNormalized', label: 'Emissor' },
        { key: 'productTypeNormalized', label: 'Ativo' },
        { key: 'taxNormalized', label: 'Indexador' },
        { key: 'pricingMethod', label: 'Tipo marcação', highlighted: true },
        { key: 'availableQuantityNormalized', label: 'Qtd. disponível' },
        { key: 'blockedQuantityNormalized', label: 'Qtd. bloqueada' },
        { key: 'quantityNormalized', label: 'Qtd. total' },
        { key: 'maturityDateNormalized', label: 'Vencimento' },
        { key: 'valueNormalized', label: 'Valor bruto' },
        { key: 'variationNormalized', label: 'Variação', coloredField: 'variationType' },
        { key: 'productCodeNormalized', label: 'Código do ativo' },
      ]}
      mobileFields={[
        { key: 'productNameNormalized', label: 'Emissor' },
        { key: 'productTypeNormalized', label: 'Tipo' },
        { key: 'taxNormalized', label: 'Indexador' },
        { key: 'pricingMethod', label: 'Tipo marcação', highlighted: true },
        { key: 'availableQuantityNormalized', label: 'Qtd. disp.' },
        { key: 'blockedQuantityNormalized', label: 'Qtd. bloq.' },
        { key: 'quantityNormalized', label: 'Qtd. total' },
      ]}
    />
  );
};
